import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { DatePipe } from '@angular/common';
import { BackupService } from 'src/app/services/api/backup.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Datazone } from 'src/app/models/principal/permission';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/shared/custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from 'src/app/shared/custom-date-adapter';
import { DateAdapter } from 'angular-calendar';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_NONPII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_PII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_LIVE,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_ARCHIVE_LIVE,
    name: Feature.DATABASE_ARCHIVE,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];
@Component({
    selector: 'app-db-backup-form',
    templateUrl: './db-backup-form.component.html',
    styleUrls: ['./db-backup-form.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
    ],
    standalone: false
})
export class DbBackupFormComponent  implements OnInit {

  @Input() subtitle: string;
  @Input() databases: any;
  @Input() id: any;
  @Input() instance: any;
  @Input() dbResults: any;
  @Input() isExtendBackup: boolean;
  @Input() form: any;
private destroyRef = inject(DestroyRef);
  title: string;
  backupForm: FormGroup;
  Constants = Constants;
  rtnDate: Date;
  pitrDate: Date;
  rtnDateError: boolean;
  pitrDateError: boolean;
  date: string;
  isLoading: boolean;
  serverNames: any = [];
  componentDatabases: any = [];
  today = new Date();
  tomorrow = new Date();
  instanceCreated: Date;
  rtnEndDate: Date;
  disableSubmit = true;
  backupType: string;
  showRtnType = false;
  showRtnDate = false;
  expiryLimit: Date;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  existingExpiry: Date;
  dbTypes = [
    {
      name: translate('INSTANCE_DETAILS.MONTHEND'),
      value: 'monthEnd'
    },
    {
      name: translate('INSTANCE_DETAILS.YEAR_END'),
      value: 'yearEnd'
    },
    {
      name: translate('INSTANCE_DETAILS.ADHOC'),
      value: 'adhoc'
    }
  ];
  snapshotDBTypes = [
    {
      name: translate('DB_DETAILS.ADHOC'),
      value: 'adhoc'
    }
  ];
  backupTypes = [
    {
      name: translate('INSTANCE_DETAILS.SNAPSHOT'),
      value: 'snapshot',
      disabled: false,
      checked: false
    },
    {
      name: translate('INSTANCE_DETAILS.ARCHIVE'),
      value: 'archive',
      disabled: false,
      checked: false
    }
  ];
  dbType = {
    SNAPSHOT: 'snapshot',
    ARCHIVE: 'archive'
  }
  ltrType = {
    MONTH: 'monthEnd',
    YEAR: 'yearEnd',
    ADHOC: 'adhoc'
  }
  groupedData: any = [];
  typeGroup: any = [];
  filteredBackupIntervals: any = [];
  isPostgres: boolean;

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private dialog: MatDialog,
    public datePipe: DatePipe, private toastrService: CustomToastrService, private backupService: BackupService,
    private featurePermissionsService: FeaturePermissionsService,private dbBackupService: DbbackupService
  ) {

  }

  ngOnInit(): void {
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    if (this.isExtendBackup) {
    const snapshot = this.dbResults?.find(item =>
      item.id === this.form?.id
    );
    if (snapshot?.expiryDate) {
      this.expiryLimit = new Date(snapshot.expiryDate);
      const maxExtendDate = new Date(this.expiryLimit);
      maxExtendDate.setDate(maxExtendDate.getDate() + 180);
      this.rtnEndDate = maxExtendDate;
    }
  }
    this.tomorrow.setDate(this.today.getDate() + 1);
    const instanceDate = new Date(this.instance?.dateCreated);
    let result = new Date();
    let Difference_In_Time =
    result.getTime() - instanceDate.getTime();
    let Difference_In_Days =
    Math.round
        (Difference_In_Time / (1000 * 3600 * 24));
        if(Difference_In_Days < 30) {
          this.instanceCreated = new Date(this.instance?.dateCreated);
        } else {
          result.setDate(result.getDate() - 30);
          this.instanceCreated = result;
        }
    this.title = this.isExtendBackup ? translate('INSTANCE_DETAILS.EXTEND_BACKUP') : translate('INSTANCE_DETAILS.CREATE_NEW_BP');
    this.createForm();
    this.databases?.forEach(item => {
    let typeGroup = this.groupedData.find(group => group.type === item.type);
    if (!typeGroup) {
      typeGroup = { type: item.type, servers: [] };
      this.groupedData.push(typeGroup);
    }

    let server = typeGroup.servers.find(s => s.name === item.serverName);
    if (!server) {
      server = { name: item.serverName, databases: [] };
      typeGroup.servers.push(server);
    }

    if (!server.databases.includes(item.databaseName)) {
      server.databases.push(item.databaseName);
    }
});

    const ticket = document.querySelector('input[id="ticket"]');
    ticket.addEventListener("blur", (event) => {
      if (this.backupForm.get('ticketNumber').touched && this.backupForm.get('ticketNumber').value && !this.isExtendBackup) {
        const dbResults = this.dbResults?.filter(item => item.status !== 'failed');
        if (dbResults.find(item => item.ticketNumber === this.backupForm.get('ticketNumber').value)) {
          setTimeout(() => this.backupForm.get('ticketNumber').setErrors({'duplicateTicket': true}));
        }
      }
    });
  }

  disableOldDates = (date: Date | null): boolean => {
    if (!date || !this.expiryLimit) return true;
    return date > this.expiryLimit;
  };

  createForm(): void {
    const formConfig: any = {
      backupType: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      backupInterval: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      type: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      serverName: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      databaseName: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      hour: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      minute: [{ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]],
      ticketNumber: ['', [Validators.required, Validators.minLength(2), Validators.pattern(/^ITSM[a-zA-Z0-9]*/)]]
    };

    this.backupForm = this.formBuilder.group(formConfig);
  }

/***
 * Returns the matched server name for the particular db type
 */
  componentSelected() {
    const selectedType = this.backupForm.get('type')?.value;
    const selectedGroup = this.groupedData?.find(group => group.type === selectedType);
    this.serverNames = selectedGroup ? selectedGroup.servers.filter((item, index) => selectedGroup.servers.findIndex(data => data.name === item.name) === index) : [];
    this.backupForm.get('serverName')?.reset();
    this.backupForm.get('databaseName')?.reset();
    this.componentDatabases = [];
    this.selectionChanged();
  }

/***
 * Returns the matched db name for the particular server name
 */
  onServerSelected() {
    const selectedType = this.backupForm.get('type')?.value;
    const selectedServer = this.backupForm.get('serverName')?.value;
    const selectedGroup = this.groupedData?.find(group => group.type === selectedType);
    if (!selectedGroup) {
      this.componentDatabases = [];
      this.backupForm.get('databaseName')?.reset();
      return;
    }
    const server = selectedGroup?.servers?.find(s => s.name === selectedServer);
    if (!server) {
      this.componentDatabases = [];
    } else {
      this.componentDatabases = server.databases !== null && server.databases !== undefined ? server.databases : [];
      this.componentDatabases = server && server.databases ? server.databases.filter(db => db !== undefined) : [];
    }
    this.backupForm.get('databaseName')?.reset();
    this.selectionChanged();
  }

  getDeployment(): any {
    this.rtnDateError = false;
    this.pitrDateError = false;
    let error = false;
    if (!FormUtilService.validateForm(this.backupForm)) {
      error = true;
    }
    if (this.backupType === this.dbType.SNAPSHOT && !this.rtnDate) {
      error = true;
      this.rtnDateError = true;
    }
    if (!this.isExtendBackup && !this.pitrDate) {
      error = true;
      this.pitrDateError = true;
    }
    if (error) {
      return;
    }
    return this.backupForm.getRawValue();
  }

  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.CREATE_BACKUP'),
        message:translate('INSTANCE_DETAILS.CREATE_BACKUP_MSG'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const data = this.backupForm.getRawValue();
          const pitrDate  = this.datePipe.transform(this.pitrDate, 'yyyy-MM-dd');
          const dateUTC = pitrDate + 'T' + (Number(this.backupForm.getRawValue().hour < 10) ? '0' + JSON.stringify(this.backupForm.getRawValue().hour) : JSON.stringify(this.backupForm.getRawValue().hour)) + ':' +
          (Number(this.backupForm.getRawValue().minute < 10) ? '0' + JSON.stringify(this.backupForm.getRawValue().minute) : JSON.stringify(this.backupForm.getRawValue().minute)) + ':' + '00Z';
          data.pitrTimestamp = dateUTC;
          let expiry;
          if (this.backupType === this.dbType.SNAPSHOT) {
            const rtnDate = new Date(this.rtnDate);
            const today = new Date();
            const diffDays = Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(rtnDate.getFullYear(), rtnDate.getMonth(), rtnDate.getDate())) / (1000 * 60 * 60 * 24)) * -1;
            const targetDate = new Date();
            targetDate.setDate(targetDate.getDate() + diffDays);
            expiry=targetDate.toISOString().split('T')[0];
          } else {
            const today = new Date();
            const finalDate = new Date();

            const ltrType = this.backupForm.get('backupInterval').value;

            if (ltrType === this.ltrType.ADHOC) {
              finalDate.setDate(today.getDate() + 7);
            } else if (ltrType === this.ltrType.MONTH) {
              finalDate.setMonth(today.getMonth() + 24);
            } else if (ltrType === this.ltrType.YEAR) {
              finalDate.setFullYear(today.getFullYear() + 7);
            }

            expiry = finalDate.toISOString().split('T')[0];
          }
          data.expirationDate=expiry;
          if (data.backupType === 'archive') {
            data.archiveType = data.ltrType;
            delete data.ltrType;
          }
          delete data.hour;
          delete data.minute;
          delete data.type;
          if (data) {
            this.isLoading = true;

            const apiData = {
              id: this.id,
              backupInterval: data.backupInterval,
              backupType: data.backupType,
              pitrTimestamp: data.pitrTimestamp,
              expirationDate: data.expirationDate,
              ticketNumber: data.ticketNumber,
              database:{
                serverName :data.serverName,
                databaseName:data.databaseName
              }
            }
            this.dbBackupService.postInstanceDbBackup(apiData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.sidenavService.closeRightSidenav(true);
              this.isLoading = false;
              setTimeout(() => {
              const title = translate('TENANT_DETAILS.DATABASE_BACKUP');
              const message = translate('INSTANCE_DETAILS.SUCCESS_DB_BACKUP');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            (error) => {
              this.isLoading = false;
              this.sidenavService.closeRightSidenav(false);
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('INSTANCE_DETAILS.BACKUP_CREATION_FAILED'),
                  description: errorMessage
                }
              });
            });
          }
        }
      });
  }

  extendBackup(): void {
  if (!this.getDeployment()) {
    return;
  }
  this.dialog.open(ConfirmationDialogComponent, {
    panelClass: 'default-dialog-wrapper',
    width: '566px',
    autoFocus: false,
    data: {
      title: translate('INSTANCE_DETAILS.EXTEND_BACKUP'),
      message: translate('INSTANCE_DETAILS.EXTEND_BACKUP_MSG'),
      confirmButtonText: translate('BUTTONS.CONFIRM')
    }
  })
  .afterClosed()
  .pipe(takeUntilDestroyed(this.destroyRef))
  .subscribe(confirm => {
    if (confirm) {
      const data = this.backupForm.getRawValue();
      const formattedExpirationDate = this.datePipe.transform(this.rtnDate, 'yyyy-MM-dd');
      this.existingExpiry = new Date(this.expiryLimit);
      const payload = {
        id: this.id,
        backupId: this.form.id,
        expirationDate: formattedExpirationDate,
        ticketNumber: data.ticketNumber
      };
      this.isLoading = true;
      this.dbBackupService.putInstanceDbBackupExtend(payload)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
          () => {
            this.isLoading = false;
            this.sidenavService.closeRightSidenav(true);
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.EXTEND_BACKUP');
              const message = translate('INSTANCE_DETAILS.SUCCESS_EXTEND_BACKUP');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            this.isLoading = false;
            this.sidenavService.closeRightSidenav(false);
            const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('INSTANCE_DETAILS.BACKUP_EXTENSION_FAILED'),
                description: errorMessage
              }
            });
          }
        );
    }
  });
}

  rtnDateChange(event) {
    this.rtnDateError = false;
    this.rtnDate = event.value;
    this.selectionChanged();
  }

  pitrDateChange(event) {
    this.pitrDateError = false;
    this.pitrDate = event.value;
    let result = new Date();
    result.setDate(result.getDate() + 180);
    this.rtnEndDate = result;
    this.selectionChanged();
  }

  selectionChanged() {
    this.disableSubmit = true;
    if (this.isExtendBackup) {
      const ticket = this.backupForm?.get('ticketNumber')?.value;
      if (ticket) {
      this.disableSubmit = false;
    }
  } else {
    const dbType = this.backupForm?.get('type')?.value;
    if (dbType?.toLowerCase().includes('postgres') && this.backupForm?.get('databaseName')) {
      this.backupForm.removeControl('databaseName');
      this.isPostgres = true;
    }
    if (!dbType?.toLowerCase().includes('postgres') && !this.backupForm?.get('databaseName')) {
      this.backupForm.addControl('databaseName', this.formBuilder.control({ value: '', disabled: this.isExtendBackup }, this.isExtendBackup ? [] : [Validators.required]));
      this.isPostgres = false;
    }
    if (this.backupForm.status === 'VALID' && this.pitrDate && ((this.backupType === this.dbType.SNAPSHOT && this.rtnDate) || this.backupType === this.dbType.ARCHIVE)) {
      this.disableSubmit = false;
    }
   }
  }

  onRadioButtonChange(): void {
    this.backupType = this.backupForm.get('backupType')?.value;

    if (this.backupType === this.dbType.ARCHIVE) {
      this.filteredBackupIntervals = this.dbTypes; // show all
      this.showRtnType = true;
      this.showRtnDate = false;
    } else if (this.backupType === this.dbType.SNAPSHOT) {
      this.filteredBackupIntervals = this.snapshotDBTypes; // only adhoc
      this.showRtnType = false;
      this.showRtnDate = true;
    }
    this.backupForm.reset();
    this.backupForm.get('backupType').setValue(this.backupType);
    this.pitrDateError = false;
    this.pitrDate = undefined;
    this.rtnDate = undefined;
    this.selectionChanged();
  }

}
